<template lang="html">
  <span @click="click">
    <i class="el-icon-mic"></i> {{episodeTitle}}
  </span>
</template>

<script>

  export default {
    components: {
    },
    props: {
      episodeId: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        episodeTitle: ''
      };
    },
    watch: {
    },
    computed: {
    },
    methods: {
      click: function (e) {
        window.console.log("CLICK@@@", e)
      }
    },
    mounted () {
      this.$api.episode.detail(this.episodeId)
      .then(res => {
        this.episodeTitle = res.data.title
      })      
    },
    destroyed () {
    }
  }
</script>

<style lang="css" scoped>

</style>
